import {  
  getFirestore,
  doc,
  getDoc
} from "firebase/firestore";
const getProgramInfoByIdForEdit = async function(id) {
  let db = getFirestore();

  let ref = doc(db, "wellness_program", id );
  const docSnapa = await getDoc(ref);

  return docSnapa.data();

};

export default getProgramInfoByIdForEdit;
